import React from 'react'
import {
  Card,
  Row,
  Col,
  Statistic,
  Table,
  Button,
  Space,
} from 'antd'
import { ArrowUpOutlined, DownloadOutlined, PrinterOutlined } from '@ant-design/icons'
import { useModulePermission } from '@/hooks/useModulePermission'
import '../Lead/LeadList.css'

const RevenueReport: React.FC = () => {
  const { canDownload } = useModulePermission('Reports')
  const revenueData = [
    {
      key: '1',
      month: 'June 2024',
      generators: 150000,
      consumers: 180000,
      expenses: 35000,
      netRevenue: 295000,
    },
    {
      key: '2',
      month: 'May 2024',
      generators: 140000,
      consumers: 165000,
      expenses: 32000,
      netRevenue: 273000,
    },
  ]

  const columns = [
    { title: 'Month', dataIndex: 'month', key: 'month' },
    {
      title: 'Generator Revenue (₹)',
      dataIndex: 'generators',
      key: 'generators',
    },
    {
      title: 'Consumer Revenue (₹)',
      dataIndex: 'consumers',
      key: 'consumers',
    },
    { title: 'Expenses (₹)', dataIndex: 'expenses', key: 'expenses' },
    {
      title: 'Net Revenue (₹)',
      dataIndex: 'netRevenue',
      key: 'netRevenue',
      render: (value: number) => <strong>₹{value}</strong>,
    },
  ]

  return (
    <div className="lead-list-container">
      <div className="list-header">
        <h2>Revenue Report</h2>
        <Space>
          {canDownload && <Button icon={<DownloadOutlined />}>Export Excel</Button>}
          <Button icon={<PrinterOutlined />}>Print</Button>
        </Space>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Total Revenue"
              value={568000}
              prefix="₹"
              suffix={<ArrowUpOutlined style={{ color: '#3f8600', marginLeft: '8px' }} />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Generator Revenue"
              value={290000}
              prefix="₹"
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Consumer Revenue"
              value={345000}
              prefix="₹"
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Net Profit"
              value={568000}
              prefix="₹"
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: '16px' }}>
        <h3>Monthly Revenue Breakdown</h3>
        <Table
          dataSource={revenueData}
          columns={columns}
          pagination={{ defaultPageSize: 10, pageSizeOptions: ['10', '25', '50', '100'], showSizeChanger: true }}
          rowKey="key"
        />
      </Card>
    </div>
  )
}

export default RevenueReport
